define('bindingHandlers/error',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    ko.bindingHandlers.error = {
        init: function (element, valueAccessor) {
            var $element = $(element),
                errorObservable = valueAccessor();

            $element.on('error.error-binding', function () {
                errorObservable(true);
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off('.error-binding');
            });
        }
    };
});

